function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-6021.722,14.693l-6.444-6.446a7.339,7.339,0,0,1-4.459,1.5A7.384,7.384,0,0,1-6040,2.377,7.383,7.383,0,0,1-6032.625-5a7.384,7.384,0,0,1,7.376,7.376,7.334,7.334,0,0,1-1.5,4.456l6.446,6.446a1,1,0,0,1,0,1.414,1,1,0,0,1-.708.292A1,1,0,0,1-6021.722,14.693ZM-6038,2.377a5.381,5.381,0,0,0,5.374,5.375,5.381,5.381,0,0,0,5.375-5.375A5.38,5.38,0,0,0-6032.625-3,5.381,5.381,0,0,0-6038,2.377Z",
  transform: "translate(6040 4.999)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  width: 20,
  height: 20,
  transform: "translate(0)",
  fill: "none"
});

var SvgGlobalSearchSelected = function SvgGlobalSearchSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgGlobalSearchSelected, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/GlobalSearchSelected.99514676.svg";
export { ForwardRef as ReactComponent };